import React, { useMemo } from 'react';
import DigitWheel from './DigitWheel';
import styles from './CodeLock.module.scss';

type Props = {
  value: string; // например "027"
  onChange?: (code: string) => void;
  height?: number;
  adPhase?: boolean; // true во время рекламы/запроса — принудительно завершить драг
  disabled?: boolean; // блокировка ввода
};

const LENGTH = 3;

export default function CodeLock({
  value,
  onChange,
  height = 150,
  adPhase = false,
  disabled = false,
}: Props) {
  const digits = useMemo(
    () =>
      (value || '000')
        .padStart(LENGTH, '0')
        .slice(0, LENGTH)
        .split('')
        .map(Number),
    [value],
  );

  const updateDigit = (index: number, val: number) => {
    const next = [...digits];
    next[index] = val;
    onChange?.(next.join(''));
  };

  return (
    <div className={styles.wrap}>
      {digits.map((val, idx) => (
        <DigitWheel
          key={`wheel-${idx}`}
          value={val}
          onChange={(v) => updateDigit(idx, v)}
          height={height}
          adPhase={adPhase}
          disabled={disabled}
        />
      ))}
    </div>
  );
}
